import React, { createContext, useContext, useState, useEffect } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updateProfile,
  sendEmailVerification,
} from "firebase/auth";
import { auth } from "./firebase";

const AuthContext = createContext();
export function useAuth() { return useContext(AuthContext); }

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [awaitingTwoFA, setAwaitingTwoFAState] = useState(
    () => sessionStorage.getItem("awaitingTwoFA") === "true"
  );

  function setAwaitingTwoFA(val) {
    sessionStorage.setItem("awaitingTwoFA", val ? "true" : "false");
    setAwaitingTwoFAState(val);
  }

  async function register(email, password, displayName) {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(res.user, { displayName });
    // actionCodeSettings: doğrulama sonrası login sayfasına yönlendir
    await sendEmailVerification(res.user, {
      url: window.location.origin + "/#/login",
      handleCodeInApp: false,
    });
    // Kayıt sonrası otomatik oturumu kapat — önce doğrulasın
    await signOut(auth);
    return res;
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    setAwaitingTwoFA(false);
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      // Kullanıcı oturumu kapandıysa (logout) awaitingTwoFA'yı temizle
      if (!user) {
        setAwaitingTwoFA(false);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = { currentUser, register, login, logout, awaitingTwoFA, setAwaitingTwoFA };
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
